import { getObjectKeys } from '#shared/lib/function';
import { productVariantRoute, productVariantStocksRoute } from '#shared/lib/routes';

/**
 * Единый реестр разделов формы: порядок ключей задаёт порядок в сайдбаре, route — URL раздела.
 * При добавлении раздела ProductFormSection расширится автоматически, а исчерпывающие карты
 * контента в ProductVariantSections и ProductCardStub потребуют явно реализовать новое состояние.
 */
export const PRODUCT_FORM_SECTIONS = {
    main: {
        title: 'Основная информация',
        testId: 'ProductForm.Sections.Main',
        route: productVariantRoute,
    },
    stocks: {
        title: 'Остатки',
        testId: 'ProductForm.Sections.Stocks',
        route: productVariantStocksRoute,
    },
} as const;

export type ProductFormSection = keyof typeof PRODUCT_FORM_SECTIONS;

export const PRODUCT_FORM_SECTION_IDS = getObjectKeys(PRODUCT_FORM_SECTIONS);

export const DEFAULT_PRODUCT_FORM_SECTION = 'main' satisfies ProductFormSection;
